export const update_security_transfer = `subscription update_security_transfer{
    update_security_transfer{
        transaction_code
        status
        account
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        amount
        order_date
    }
}`;
